<script lang="ts">
  import {user} from '../stores/user'
  import PoemsList from './PoemsList.svelte'
  import {t} from '../i18n'

  $: url = `/users/${$user?.id}/poems`
</script>

<PoemsList title={t.poem.my_poems.title} {url} emptyPlaceholder={t.poem.no_poems}/>
